import { call, put, takeLatest } from "redux-saga/effects";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { rootActions } from "../../actions/rootActions";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";
import { eQuocTichActionIds } from "../../action-types/category/IQuocTichActions";
import { quocTichApi } from "../../../api/category/quocTichApi";

const mainAction = rootActions.category.quocTich;
export function* quocTichSaga(): any {
    yield takeLatest(eQuocTichActionIds.LOAD_START,loadWorker);
}

function* loadWorker(): any {
    const res: IBaseResponse = yield call(quocTichApi.SelectAll);
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(toLowerCaseDeep(res.data)));
    }
    else{
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi"))
    }
}
